/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * MIME type of the file
 */
export type GenerateCommentAttachmentUploadUrlRequestDtoContentType = typeof GenerateCommentAttachmentUploadUrlRequestDtoContentType[keyof typeof GenerateCommentAttachmentUploadUrlRequestDtoContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateCommentAttachmentUploadUrlRequestDtoContentType = {
  'image/jpeg': 'image/jpeg',
  'image/jpg': 'image/jpg',
  'image/png': 'image/png',
  'text/csv': 'text/csv',
  'text/plain': 'text/plain',
  'application/vndopenxmlformats-officedocumentspreadsheetmlsheet': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vndopenxmlformats-officedocumentwordprocessingmldocument': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf': 'application/pdf',
  'application/msword': 'application/msword',
  'application/vndms-excel': 'application/vnd.ms-excel',
} as const;
